import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUIComponents, use, useTranslate } from "@bluelibs/x-ui";
import * as Ant from "antd";
import { TransactionCreateForm } from "../../config/TransactionCreateForm";
import { CompaniesCollection, ExternalsCollection, } from "@bundles/UIAppBundle/collections";
import moment from "moment";
import { useEffect, useState } from "react";
import { FileUpload } from "@bundles/UIAppBundle/components/FileUpload/FileUpload";
import { TransactionType, UserRole } from "@root/api.types";
import { useAppGuardian } from "@bundles/UIAppBundle/services/AppGuardian";
import { BankAccountsFind } from "@bundles/UIAppBundle/queries/BankAccountsFind";
import { useLazyQuery } from "@apollo/client";
const formLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
const formTailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};
export function TransactionsCreate() {
    var _a, _b;
    const UIComponents = useUIComponents();
    const t = useTranslate();
    const form = use(TransactionCreateForm, { transient: true });
    const { state } = useAppGuardian();
    const isAdmin = ((_b = (_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.roles) !== null && _b !== void 0 ? _b : []).find((role) => [UserRole.ADMIN, UserRole.SHAREHOLDER].includes(role))
        ? true
        : false;
    const externalsCollection = use(ExternalsCollection);
    const [externals, setExternals] = useState([]);
    const [externalsLoading, setExternalsLoading] = useState(false);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [formRef] = Ant.Form.useForm();
    const companyId = Ant.Form.useWatch("companyId", formRef);
    const [queryBankAccounts, { loading: bankAccountsLoading }] = useLazyQuery(BankAccountsFind, { fetchPolicy: "no-cache" });
    const [transactionType, setTransactionType] = useState("all");
    const fetchExternals = async () => {
        setExternalsLoading(true);
        let filter = {};
        switch (transactionType) {
            case "income":
                filter = { type: "client" };
                break;
            case "expense":
                filter = { type: "provider" };
                break;
            default:
                filter = undefined;
                break;
        }
        const externalsData = await externalsCollection.find({
            filters: filter,
        }, { _id: true, name: true, type: true });
        setExternals(externalsData);
        setExternalsLoading(false);
    };
    const fetchBankAccounts = async () => {
        queryBankAccounts({
            variables: {
                query: {
                    filters: {
                        $and: [
                            {
                                companyId: {
                                    $in: [
                                        {
                                            $objectId: companyId,
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                },
            },
        })
            .then((res) => { var _a, _b; return setBankAccounts((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.BankAccountsFind) !== null && _b !== void 0 ? _b : []); })
            .catch((err) => console.log(err));
    };
    useEffect(() => {
        fetchExternals();
    }, [transactionType]);
    useEffect(() => {
        fetchBankAccounts();
    }, [companyId]);
    return (_jsxs(UIComponents.AdminLayout, { children: [_jsx(Ant.PageHeader, { title: t("management.transactions.create.header"), onBack: () => window.history.back() }, void 0), _jsx(Ant.Card, { children: _jsxs(Ant.Form, Object.assign({}, formLayout, { form: formRef, requiredMark: "optional", onFinish: (document) => {
                        form.onSubmit(document, true);
                    } }, { children: [_jsx(Ant.Form.Item, Object.assign({ label: t("management.transactions.fields.transactionType") }, formLayout, { name: "type", rules: [
                                {
                                    required: true,
                                    message: t("management.transactions.fields.required"),
                                },
                            ] }, { children: _jsx(Ant.Select, { options: [
                                    {
                                        label: t("management.transactions.create.transaction_type.income"),
                                        value: TransactionType.income,
                                    },
                                    {
                                        label: t("management.transactions.create.transaction_type.expense"),
                                        value: TransactionType.expense,
                                    },
                                    {
                                        label: t("management.transactions.create.transaction_type.internal"),
                                        value: TransactionType.internal,
                                    },
                                ], style: { width: "100%" }, onChange: (type) => {
                                    setTransactionType(type);
                                    formRef.setFieldValue("type", type);
                                } }, void 0) }), void 0), transactionType !== TransactionType.internal && (_jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "externalId", label: t("management.transactions.fields.external"), rules: transactionType !== "all"
                                ? [
                                    {
                                        required: true,
                                        message: t("management.transactions.fields.required"),
                                    },
                                ]
                                : [] }, { children: externalsLoading ? (_jsx(Ant.Spin, {}, void 0)) : (_jsx(Ant.Select, { options: externals.map((e) => ({
                                    label: e.name,
                                    value: e._id,
                                })) }, void 0)) }), void 0)), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "companyId", label: t("management.transactions.fields.company"), rules: [
                                {
                                    required: true,
                                    message: t("management.transactions.fields.required"),
                                },
                            ] }, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: CompaniesCollection, field: "name", required: true }, void 0) }), void 0), companyId &&
                            (transactionType === TransactionType.expense ||
                                transactionType === TransactionType.internal) && (_jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "sourceBankAccountId", label: t("management.transactions.fields.sourceBankAccount"), rules: [
                                {
                                    required: true,
                                    message: t("management.transactions.fields.required"),
                                },
                            ] }, { children: bankAccountsLoading ? (_jsx(Ant.Spin, {}, void 0)) : (_jsx(Ant.Select, { options: bankAccounts.map((e) => ({
                                    label: `${e.formattedAccountNumber}`,
                                    value: e._id,
                                })) }, void 0)) }), void 0)), companyId &&
                            (transactionType === TransactionType.income ||
                                transactionType === TransactionType.internal) && (_jsx(Ant.Form.Item, Object.assign({}, formLayout, { label: t("management.transactions.fields.destinationBankAccount"), name: "destinationBankAccountId", rules: [
                                {
                                    required: true,
                                    message: t("management.transactions.fields.required"),
                                },
                            ] }, { children: bankAccountsLoading ? (_jsx(Ant.Spin, {}, void 0)) : (_jsx(Ant.Select, { options: bankAccounts.map((e) => ({
                                    label: `${e.formattedAccountNumber}`,
                                    value: e._id,
                                })) }, void 0)) }), void 0)), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "transactionIdentifier", label: t("management.transactions.fields.transactionIdentifier") }, { children: _jsx(Ant.Input, {}, void 0) }), void 0), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "amount", label: t("management.transactions.fields.amount"), rules: [
                                {
                                    required: true,
                                    message: t("management.transactions.fields.required"),
                                },
                            ] }, { children: _jsx(Ant.InputNumber, { width: "100%", min: 1 }, void 0) }), void 0), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "notes", label: t("management.transactions.fields.notes") }, { children: _jsx(Ant.Input.TextArea, { rows: 10, style: { minHeight: "200px", maxHeight: "400px" } }, void 0) }), void 0), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "transactionDate", label: t("management.transactions.fields.transactionDate"), rules: [
                                {
                                    required: true,
                                    message: t("management.transactions.fields.required"),
                                },
                            ], initialValue: moment() }, { children: _jsx(Ant.DatePicker, { defaultValue: moment() }, void 0) }), void 0), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "dueDate", label: t("management.transactions.fields.dueDate"), rules: [
                                {
                                    required: true,
                                    message: t("management.transactions.fields.required"),
                                },
                            ] }, { children: _jsx(Ant.DatePicker, {}, void 0) }), void 0), isAdmin && (_jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "isCompleted", label: t("management.transactions.fields.isCompleted"), rules: [
                                {
                                    required: true,
                                    message: t("management.transactions.fields.required"),
                                },
                            ], initialValue: false }, { children: _jsxs(Ant.Radio.Group, { children: [_jsx(Ant.Radio, Object.assign({ value: false }, { children: t("management.transactions.create.no") }), 0), _jsx(Ant.Radio, Object.assign({ value: true }, { children: t("management.transactions.create.yes") }), 1)] }, void 0) }), void 0)), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "transactionFilesIds", label: t("management.transactions.fields.transactionFiles") }, { children: _jsx(FileUpload, { onChange: (ids) => formRef.setFieldValue("transactionFilesIds", ids) }, void 0) }), void 0), _jsx(Ant.Form.Item, Object.assign({}, formTailLayout, { children: _jsx(Ant.Button, Object.assign({ type: "primary", htmlType: "submit" }, { children: t("generics.submit") }), void 0) }), void 0)] }), void 0) }, void 0)] }, void 0));
}
